import(/* webpackMode: "eager" */ "/vercel/path0/app/not-found.js");
